export default function Instruction() {
    return {
        title: '',
        instruction: ''
    };
}
